// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.e-listbox-wrapper {
    /*width: fit-content  !important;*/
    height: fit-content  !important;   
    
  }
  .e-listbox-wrapper ul {
    /*display: flex;
    list-style: none;
    flex-wrap: wrap;
    justify-content: center;*/
    display: grid;
    grid-auto-flow: row;
    grid-template-columns: repeat(4, 1fr);   
    
    
  }
  .column2 .e-listbox-wrapper ul {
    grid-template-columns: repeat(2, 1fr) !important;
  } 
  .column3 .e-listbox-wrapper ul {
    grid-template-columns: repeat(3, 1fr) !important;
  } 
  .column4 .e-listbox-wrapper ul {
    grid-template-columns: repeat(4, 1fr) !important;
  } 
  .column5 .e-listbox-wrapper ul {
    grid-template-columns: repeat(5, 1fr) !important;
  } 
  .column6 .e-listbox-wrapper ul {
    grid-template-columns: repeat(6, 1fr) !important;
  }   
  .column7 .e-listbox-wrapper ul {
    grid-template-columns: repeat(7, 1fr) !important;
  } 
  li { 
    white-space: nowrap;
    margin:2px;
    padding: 1px;
    border: 1px solid #eee !important;
    text-align: center; 
    align-items: center;
    justify-content: center;
    text-wrap: wrap;
    /*width: 20%;*/
    overflow: hidden;
    text-overflow: '.';
    height: 48px  !important;  
    display: box;
    display: -webkit-box;  
    box-orient: vertical;
    -webkit-box-orient: vertical;
    -webkit-box-pack: center;
    box-align: center;
    -webkit-box-align: center;
    box-pack: end;
    -webkit-box-pack: end;
  }
  .line1 li {
    height: 32px  !important;
    -webkit-line-clamp: 1;
  }
  .line2 li {
    height: 48px  !important;
    -webkit-line-clamp: 2;
  }
  .line3 li {
    height: 64px  !important;
    -webkit-line-clamp: 3;
  }
  .line4 li {
    height: 80px  !important;
    -webkit-line-clamp: 4;
  }
  .line5 li {
    height: 96px  !important;
    -webkit-line-clamp: 5;
  }


  .colorPalette .e-btn{
    background-color: transparent !important;
  }

  li.e-selected { 
    border: 1px solid #9e0606 !important;

  }

  #divCatalogue li{ text-align: center; }
  #divEntity li{ text-align: center; }

  button{
    white-space: normal !important;
  }
  
.e-switch-wrapper.handle-text {
  width: 70px !important;
  height: 30px;
}
.e-switch-wrapper .e-switch-inner, .e-css.e-switch-wrapper .e-switch-inner{
  border-radius:5px !important;
}
.e-dropdown-btn .e-caret::before, .e-dropdown-btn.e-btn .e-caret::before{
  border-top:2px solid #999 !important ;
  font-size:20px!important ;
  
}
.info.e-toast-container .e-toast {
  background-color: #bddfeb !important;
}
.danger.e-toast-container .e-toast {
  background-color: #e29c9c !important;
}
.warning.e-toast-container .e-toast {
  background-color: #F4D160 !important;
}
.success.e-toast-container .e-toast {
  background-color: #b6e959 !important;
}

`, "",{"version":3,"sources":["webpack://./src/pages/CSS/POSMenu.css"],"names":[],"mappings":"AAAA;IACI,kCAAkC;IAClC,+BAA+B;;EAEjC;EACA;IACE;;;6BAGyB;IACzB,aAAa;IACb,mBAAmB;IACnB,qCAAqC;;;EAGvC;EACA;IACE,gDAAgD;EAClD;EACA;IACE,gDAAgD;EAClD;EACA;IACE,gDAAgD;EAClD;EACA;IACE,gDAAgD;EAClD;EACA;IACE,gDAAgD;EAClD;EACA;IACE,gDAAgD;EAClD;EACA;IACE,mBAAmB;IACnB,UAAU;IACV,YAAY;IACZ,iCAAiC;IACjC,kBAAkB;IAClB,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,kBAAkB;IAClB,wBAAwB;IACxB,YAAY;IACZ,oBAAoB;IACpB,oBAAoB;IACpB,4BAA4B;IAC5B,wBAAwB;IACxB,iBAAiB;IACjB,yBAAyB;IACzB,aAAa;IACb,qBAAqB;EACvB;EACA;IACE,wBAAwB;IACxB,qBAAqB;EACvB;EACA;IACE,wBAAwB;IACxB,qBAAqB;EACvB;EACA;IACE,wBAAwB;IACxB,qBAAqB;EACvB;EACA;IACE,wBAAwB;IACxB,qBAAqB;EACvB;EACA;IACE,wBAAwB;IACxB,qBAAqB;EACvB;;;EAGA;IACE,wCAAwC;EAC1C;;EAEA;IACE,oCAAoC;;EAEtC;;EAEA,kBAAkB,kBAAkB,EAAE;EACtC,eAAe,kBAAkB,EAAE;;EAEnC;IACE,8BAA8B;EAChC;;AAEF;EACE,sBAAsB;EACtB,YAAY;AACd;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,qCAAqC;EACrC,yBAAyB;;AAE3B;AACA;EACE,oCAAoC;AACtC;AACA;EACE,oCAAoC;AACtC;AACA;EACE,oCAAoC;AACtC;AACA;EACE,oCAAoC;AACtC","sourcesContent":[".e-listbox-wrapper {\r\n    /*width: fit-content  !important;*/\r\n    height: fit-content  !important;   \r\n    \r\n  }\r\n  .e-listbox-wrapper ul {\r\n    /*display: flex;\r\n    list-style: none;\r\n    flex-wrap: wrap;\r\n    justify-content: center;*/\r\n    display: grid;\r\n    grid-auto-flow: row;\r\n    grid-template-columns: repeat(4, 1fr);   \r\n    \r\n    \r\n  }\r\n  .column2 .e-listbox-wrapper ul {\r\n    grid-template-columns: repeat(2, 1fr) !important;\r\n  } \r\n  .column3 .e-listbox-wrapper ul {\r\n    grid-template-columns: repeat(3, 1fr) !important;\r\n  } \r\n  .column4 .e-listbox-wrapper ul {\r\n    grid-template-columns: repeat(4, 1fr) !important;\r\n  } \r\n  .column5 .e-listbox-wrapper ul {\r\n    grid-template-columns: repeat(5, 1fr) !important;\r\n  } \r\n  .column6 .e-listbox-wrapper ul {\r\n    grid-template-columns: repeat(6, 1fr) !important;\r\n  }   \r\n  .column7 .e-listbox-wrapper ul {\r\n    grid-template-columns: repeat(7, 1fr) !important;\r\n  } \r\n  li { \r\n    white-space: nowrap;\r\n    margin:2px;\r\n    padding: 1px;\r\n    border: 1px solid #eee !important;\r\n    text-align: center; \r\n    align-items: center;\r\n    justify-content: center;\r\n    text-wrap: wrap;\r\n    /*width: 20%;*/\r\n    overflow: hidden;\r\n    text-overflow: '.';\r\n    height: 48px  !important;  \r\n    display: box;\r\n    display: -webkit-box;  \r\n    box-orient: vertical;\r\n    -webkit-box-orient: vertical;\r\n    -webkit-box-pack: center;\r\n    box-align: center;\r\n    -webkit-box-align: center;\r\n    box-pack: end;\r\n    -webkit-box-pack: end;\r\n  }\r\n  .line1 li {\r\n    height: 32px  !important;\r\n    -webkit-line-clamp: 1;\r\n  }\r\n  .line2 li {\r\n    height: 48px  !important;\r\n    -webkit-line-clamp: 2;\r\n  }\r\n  .line3 li {\r\n    height: 64px  !important;\r\n    -webkit-line-clamp: 3;\r\n  }\r\n  .line4 li {\r\n    height: 80px  !important;\r\n    -webkit-line-clamp: 4;\r\n  }\r\n  .line5 li {\r\n    height: 96px  !important;\r\n    -webkit-line-clamp: 5;\r\n  }\r\n\r\n\r\n  .colorPalette .e-btn{\r\n    background-color: transparent !important;\r\n  }\r\n\r\n  li.e-selected { \r\n    border: 1px solid #9e0606 !important;\r\n\r\n  }\r\n\r\n  #divCatalogue li{ text-align: center; }\r\n  #divEntity li{ text-align: center; }\r\n\r\n  button{\r\n    white-space: normal !important;\r\n  }\r\n  \r\n.e-switch-wrapper.handle-text {\r\n  width: 70px !important;\r\n  height: 30px;\r\n}\r\n.e-switch-wrapper .e-switch-inner, .e-css.e-switch-wrapper .e-switch-inner{\r\n  border-radius:5px !important;\r\n}\r\n.e-dropdown-btn .e-caret::before, .e-dropdown-btn.e-btn .e-caret::before{\r\n  border-top:2px solid #999 !important ;\r\n  font-size:20px!important ;\r\n  \r\n}\r\n.info.e-toast-container .e-toast {\r\n  background-color: #bddfeb !important;\r\n}\r\n.danger.e-toast-container .e-toast {\r\n  background-color: #e29c9c !important;\r\n}\r\n.warning.e-toast-container .e-toast {\r\n  background-color: #F4D160 !important;\r\n}\r\n.success.e-toast-container .e-toast {\r\n  background-color: #b6e959 !important;\r\n}\r\n\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
